import { useAuth0, User } from '@auth0/auth0-react';
import type {CSSProperties} from 'react';

const Profile: React.FC = () => {
    const { user, isAuthenticated } = useAuth0<User>();

    if (!isAuthenticated || !user) {
        return null;
    }

    const profileStyle: CSSProperties = {
        margin: '20px 0',
        textAlign: 'left',
        maxWidth: '500px',
        padding: '20px',
        borderRadius: '8px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef'
    };

    const imageStyle: CSSProperties = {
        borderRadius: '50%',
        width: '80px',
        height: '80px',
        marginBottom: '10px'
    };

    const preStyle: CSSProperties = {
        textAlign: 'left',
        fontSize: '12px',
        backgroundColor: '#ffffff',
        padding: '15px',
        borderRadius: '4px',
        overflow: 'auto',
        border: '1px solid #dee2e6',
        maxHeight: '300px'
    };

    return (
        <div style={profileStyle}>
            <h2>Welcome to TheMousy!</h2>
            {user.picture && (
                <img
                    src={user.picture}
                    alt={user.name || 'User'}
                    style={imageStyle}
                />
            )}
            <p><strong>Name:</strong> {user.name}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>User ID:</strong> {user.sub}</p>
            <details>
                <summary style={{ cursor: 'pointer', marginTop: '10px' }}>
                    View Full User Profile
                </summary>
                <pre style={preStyle}>
          {JSON.stringify(user, null, 2)}
        </pre>
            </details>
        </div>
    );
};

export default Profile;